/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskProgramSrvcAccomplishment
 */
export interface ExecRiskProgramSrvcAccomplishment {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgramSrvcAccomplishment
     */
    DescriptionProgramSrvcAccomTxt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgramSrvcAccomplishment
     */
    GrantsAndAllocationsAmt?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProgramSrvcAccomplishment
     */
    ForeignGrantsInd?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskProgramSrvcAccomplishment
     */
    ProgramServiceExpensesAmt?: number;
}

/**
 * Check if a given object implements the ExecRiskProgramSrvcAccomplishment interface.
 */
export function instanceOfExecRiskProgramSrvcAccomplishment(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskProgramSrvcAccomplishmentFromJSON(json: any): ExecRiskProgramSrvcAccomplishment {
    return ExecRiskProgramSrvcAccomplishmentFromJSONTyped(json, false);
}

export function ExecRiskProgramSrvcAccomplishmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskProgramSrvcAccomplishment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'DescriptionProgramSrvcAccomTxt': !exists(json, 'DescriptionProgramSrvcAccomTxt') ? undefined : json['DescriptionProgramSrvcAccomTxt'],
        'GrantsAndAllocationsAmt': !exists(json, 'GrantsAndAllocationsAmt') ? undefined : json['GrantsAndAllocationsAmt'],
        'ForeignGrantsInd': !exists(json, 'ForeignGrantsInd') ? undefined : json['ForeignGrantsInd'],
        'ProgramServiceExpensesAmt': !exists(json, 'ProgramServiceExpensesAmt') ? undefined : json['ProgramServiceExpensesAmt'],
    };
}

export function ExecRiskProgramSrvcAccomplishmentToJSON(value?: ExecRiskProgramSrvcAccomplishment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'DescriptionProgramSrvcAccomTxt': value.DescriptionProgramSrvcAccomTxt,
        'GrantsAndAllocationsAmt': value.GrantsAndAllocationsAmt,
        'ForeignGrantsInd': value.ForeignGrantsInd,
        'ProgramServiceExpensesAmt': value.ProgramServiceExpensesAmt,
    };
}

